export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-200 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-mail-line mr-1"></i>互动交流
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">投稿联系</h2>
          <p className="text-sm text-foreground-500 mb-8 max-w-lg mx-auto">
            无论你是想推荐好片、反馈问题还是洽谈合作，我们都期待听到你的声音
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="bg-background-100 rounded-xl p-6 border border-secondary-200/50">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-movie-2-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-1">影片推荐</h3>
              <p className="text-xs text-foreground-500">发现好片想推荐给我们？欢迎投稿，优质推荐将获得首页展示机会。</p>
              <a href="mailto:submit@momo.movies" className="inline-block mt-3 text-sm text-primary-600 font-medium whitespace-nowrap">
                submit@momo.movies
              </a>
            </div>
            <div className="bg-background-100 rounded-xl p-6 border border-secondary-200/50">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-bug-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">播放卡顿、页面异常？告诉我们，技术团队会第一时间处理。</p>
              <a href="mailto:feedback@momo.movies" className="inline-block mt-3 text-sm text-accent-600 font-medium whitespace-nowrap">
                feedback@momo.movies
              </a>
            </div>
            <div className="bg-background-100 rounded-xl p-6 border border-secondary-200/50">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-200 text-secondary-600 mx-auto mb-3">
                <i className="ri-briefcase-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">广告投放、内容合作、品牌联名，期待与你携手共赢。</p>
              <a href="mailto:biz@momo.movies" className="inline-block mt-3 text-sm text-secondary-600 font-medium whitespace-nowrap">
                biz@momo.movies
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}